import { useCallback } from 'react';
import { scaleText, scaleImage } from '../services/ScaleService';


export function useEditorHistoryHandlers({
  stage,
  deleteElement,
  historyUndo,
  historyRedo,
  refreshLayersStructure,
  setSelectedGroup,
}) {
  const afterHistoryChangedAction = useCallback(
    (stg, layer) => {
      for (const text of layer.find('Text')) scaleText(text);
      for (const image of layer.find('Image')) scaleImage(image);
      stg.draw();
      layer.draw();
      refreshLayersStructure();
      setSelectedGroup(null);
    },
    [refreshLayersStructure, setSelectedGroup],
  );

  const handleHistoryUndo = useCallback(() => {
    historyUndo(stage, deleteElement, afterHistoryChangedAction);
  }, [stage, deleteElement, historyUndo, afterHistoryChangedAction]);

  const handleHistoryRedo = useCallback(() => {
    historyRedo(stage, deleteElement, afterHistoryChangedAction);
  }, [stage, deleteElement, historyRedo, afterHistoryChangedAction]);

  return { afterHistoryChangedAction, handleHistoryUndo, handleHistoryRedo };
}
